import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import { AdminRootContainer } from '@/modules/admin/admin-root'
import { AllPostsContainer } from '@/modules/admin/all-posts/all-posts.container'
import { ImpactQueryComponent } from '@/modules/admin/impact/impact-query.component'
import { OnboardingUsers } from '@/modules/admin/onboarding-users'
import { AnniversaryCardManagementContainer } from '@/modules/anniversary-card/anniversary-card-management.container'
import { AnniversaryCardManagementValidateContainer } from '@/modules/anniversary-card/anniversary-card-management-validate.container'
import { AnniversaryCardRedirect } from '@/modules/anniversary-card/anniversary-card-redirect.component'
import { CalendarContainer } from '@/modules/calendar/calendar.container'
import { ChatGptContainer } from '@/modules/chat-gpt/chat-gpt.container'
import { DepartmentContainer } from '@/modules/department/department.container'
import { DiscoverContainer } from '@/modules/discover/discover.container'
import { GameHubContainer } from '@/modules/game-hub/game-hub.container'
import { GroupContainer } from '@/modules/group/group.container'
import { KnowledgeContainer } from '@/modules/knowledge/knowledge.container'
import { KPIContainer } from '@/modules/kpi/kpi.container'
import { MeContainer } from '@/modules/me/me.container'
import { NotificationContainer } from '@/modules/notification/notification.container'
import { NotificationSettingContainer } from '@/modules/notification-setting/notification-setting.container'
import { SinglePostContainer } from '@/modules/post/single-post'
// import { SearchContainer } from '@/modules/search/search.container'
import {
  EntertainSectionContainer,
  NewAgoranSectionContainer,
  OthersSectionContainer,
} from '@/modules/section/section-container'
import { ToolsContainer } from '@/modules/tools/tools.container'
import { UserContainer } from '@/modules/user/user.container'
import { UserManageContainer } from '@/modules/user/user-manage/user-manage.container'
import { routes } from '@/routes'

export const Routes = () => {
  return (
    <Switch>
      <Route path={routes.users.page(':userId')}>
        <UserContainer />
      </Route>
      <Route path={routes.groups.page(':groupId')}>
        <GroupContainer />
      </Route>
      <Route path={routes.me.manageMy()}>
        <UserManageContainer />
      </Route>
      <Route path={routes.posts.page(':postId')}>
        <SinglePostContainer />
      </Route>
      <Route path={routes.notifications.home()}>
        <NotificationContainer />
      </Route>
      <Route path={routes.notificationSettings.home()}>
        <NotificationSettingContainer />
      </Route>
      {/* <Route path={routes.search.home()}>
        <SearchContainer />
      </Route> */}
      <Route path={routes.discover.home()}>
        <DiscoverContainer />
      </Route>
      <Route path={routes.knowledgebase.home()}>
        <KnowledgeContainer />
      </Route>
      <Route path={routes.tools.departments()}>
        <DepartmentContainer />
      </Route>
      <Route path={routes.tools.home()}>
        <ToolsContainer />
      </Route>
      <Route path={routes.me.home()}>
        <MeContainer />
      </Route>
      <Route path={routes.admin.system()}>
        <AdminRootContainer />
      </Route>
      <Route path={routes.admin.onboardingUsers()}>
        <OnboardingUsers />
      </Route>
      <Route path={routes.admin.allPosts()}>
        <AllPostsContainer />
      </Route>
      <Route path={routes.admin.impactQuery()}>
        <ImpactQueryComponent />
      </Route>
      <Route path={routes.section.newAgoran()}>
        <NewAgoranSectionContainer />
      </Route>
      <Route path={routes.section.entertain()}>
        <EntertainSectionContainer />
      </Route>
      <Route path={routes.statistics.home()}>
        <KPIContainer />
      </Route>
      <Route path={routes.calendar.home()}>
        <CalendarContainer />
      </Route>
      <Route path={routes.taleGpt.home()}>
        <ChatGptContainer />
      </Route>
      <Route path={routes.gameHub.home()}>
        <GameHubContainer />
      </Route>
      <Route path={routes.anniversaryCardManagement.home()}>
        <AnniversaryCardManagementContainer />
      </Route>
      <Route path={routes.anniversaryCardManagement.validate()}>
        <AnniversaryCardManagementValidateContainer />
      </Route>
      <Route path={routes.anniversaryCardManagement.redirect()}>
        <AnniversaryCardRedirect />
      </Route>
      <Route path={routes.menu()} />
      <Route path={routes.section.updates()}>
        <OthersSectionContainer />
      </Route>
      <Redirect to='/' />
    </Switch>
  )
}
